import List from "@mui/material/List";
import { useSelector } from "react-redux";
import { AppBar } from "@mui/material";
import SideBar from "rc-material-sidebar";
import SpeedIcon from "@mui/icons-material/Speed";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import CategoryIcon from "@mui/icons-material/Category";

const normalizeType = (type) =>
  String(type || "")
    .trim()
    .replace(/,+$/, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const AdminSidebar = ({ open }) => {
  const { userData } = useSelector((state) => state.mainReducer);
  const allowedTypes = new Set((userData?.type || []).map(normalizeType));
  console.log(allowedTypes, "userData from sidebar");
  const onClick = (e, item) => {
    // console.log(e, item);
  };

  const allItems = [
    {
      key: "1",
      label: "Dashboard",
      link: "/app",
      icon: <SpeedIcon sx={{ width: "34px" }} />,
      //roles: [ADMIN, USER],
      typeKey: "Dashboard",
      permissionKeys: ["Dashboard"],
    },

    {
      key: "2",
      label: "Blogs",
      link: "/app/blogs",
      icon: <ManageAccountsIcon sx={{ width: "34px" }} />,
      // roles: [ADMIN],
      activeChildrenPath: ["/app/blog/add"],
      typeKey: "Blog",
      permissionKeys: ["Blog"],
    },
    {
      key: "3",
      label: "Case Studies",
      link: "/app/case-studies",
      icon: <MenuBookIcon sx={{ width: "34px" }} />,
      // roles: [ADMIN],
      activeChildrenPath: ["/app/add-case-studies"],
      typeKey: "Case-Study",
      permissionKeys: ["Case-Study", "Case Studies", "Case Study"],
    },
    {
      key: "4",
      label: "Categories",
      link: "/app/categories",
      icon: <CategoryIcon sx={{ width: "34px" }} />,
      typeKey: "Case-Study",
      permissionKeys: ["Case-Study", "Case Studies", "Case Study"],
    },
    {
      key: "5",
      label: "Newsroom",
      link: "/app/pr-articles",
      icon: <MenuBookIcon sx={{ width: "34px" }} />,
      // roles: [ADMIN],
      activeChildrenPath: ["/app/add-pr-article"],
      typeKey: "Pr-Article",
      permissionKeys: [
        "Newsroom",
        "Pr-Article",
        "PR Articles",
        "Menu Articles",
      ],
    },
    {
      key: "6",
      label: "Menu Articles",
      link: "/app/menu-articles",
      icon: <MenuBookIcon sx={{ width: "34px" }} />,
      // roles: [ADMIN],
      activeChildrenPath: ["/app/add-menu-article"],
      typeKey: "Menu-Article",
      permissionKeys: [
        "Menu-Article",
        "MenuArticle",
        "Menu Article",
        "menu_article",
      ],
    },
    // {
    //   key: "5",
    //   label: "Menu Articles",
    //   link: "/app/menu-articles",
    //   icon: <MenuBookIcon sx={{ width: "34px" }} />,
    //   activeChildrenPath: ["/app/add-menu-article"],
    //   //  typeKey: ["Menu-Article", "MenuArticle", "Menu Article", "menu_article"],
    // },
    {
      key: "6",
      label: "Gallery",
      link: "/app/gallery",
      icon: <ManageAccountsIcon sx={{ width: "34px" }} />,
      // roles: [ADMIN],
      activeChildrenPath: ["/app/add-gallery"],
      typeKey: "Gallery",
      permissionKeys: ["Gallery"],
    },
  ];

  // const filteredItems = allItems.filter((item) =>
  //   item.roles.includes(userData?.role)
  // );
  const filteredItems = allItems.filter((item) =>
    (item.permissionKeys || [item.typeKey]).some((permissionKey) =>
      allowedTypes.has(normalizeType(permissionKey)),
    ),
  );
  return (
    <AppBar
      position="fixed"
      component="div"
      color="transparent"
      elevation={0}
      sx={{
        width: open ? 240 : 66,
        right: "inherit",
        height: "calc(100% - 64px)",
        top: 64,
      }}
    >
      <List className="sidebarMenu">
        <SideBar
          items={filteredItems}
          variant={open ? "full" : "mini"}
          onClick={onClick}
        />
      </List>
    </AppBar>
  );
};

export default AdminSidebar;
